export default __webpack_public_path__ + "static/media/Warlord's Greatbow.13534ff4.jpg";